import * as React from 'react';
const FlagIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.421 4.166c-.943.815-1.783.993-2.585.898-.846-.101-1.681-.508-2.614-.969l-.039-.019c-.887-.438-1.867-.922-2.9-1.046-1.09-.13-2.208.142-3.353 1.13a.5.5 0 0 0-.18.383V16.5a.5.5 0 0 0 1.002 0v-3.896c.873-.693 1.66-.844 2.412-.755.846.101 1.681.508 2.614.969l.039.02c.887.437 1.867.922 2.9 1.045 1.093.13 2.212-.143 3.36-1.135a.5.5 0 0 0 .173-.378V4.544a.5.5 0 0 0-.829-.378m-10.67 7.227a3.94 3.94 0 0 1 2.532-.537c1.033.124 2.013.608 2.9 1.046l.04.02c.932.46 1.767.867 2.613.968.752.09 1.539-.062 2.412-.755V5.52a3.94 3.94 0 0 1-2.53.537c-1.034-.123-2.014-.608-2.901-1.046l-.04-.02c-.932-.46-1.767-.867-2.613-.968-.752-.09-1.539.062-2.412.755z"
      fill="currentColor"
    />
  </svg>
);
export default FlagIcon;
